import React from 'react';
import ImageTuning from 'components/commandpanel/ImageTuning/ImageTuning';
import { IStyle } from 'Styles';
import {
  useExperimentImagingDisabledState,
  useExperimentStates,
  useIsWellImagingEnabled,
  usePlateImagingState,
  useToggleWellDropImage,
} from 'components/Experiment/hooks';
import { useRMDispatch } from 'redux/hooks';
import { ITabItem } from 'components/tab';
import BaseSidePanel from 'components/sidePanel/baseSidePanel';
import ImagingToggles, {
  ImagingToggleProps,
} from '../ExperimentPanel/ExperimentTools/ImagingTools';
import SideBarComponent from '../ExperimentPanel/SideBarComponent/SideBarComponent';
import { togglePlateImaging } from 'redux/reducers/experimentDataReducer';
import ExperimentService from 'business/services/ExperimentService';
import { useModalHandlers } from 'components/modal';
import { PlatesImagingTaskDTO } from 'business/models/Models';
import DisablePlateImagingModal from './DisablePlateImagingModal';
import DropImageSettings from '../ExperimentPanel/ExperimentTools/DropImageSettings';

import useRMLite from 'CustomHooks/useRMLite';
import { useSelectedDropImageParameters } from 'redux/hooks/experiment';

const ImageTuningContainer = () => {
  const dispatch = useRMDispatch();
  const { exp } = useExperimentStates();
  const plateImagingEnabled = usePlateImagingState();
  const experimentImagingDisabled = useExperimentImagingDisabledState();
  const { showModal, hideModal } = useModalHandlers();
  const isMultiPlateExperiment = exp?.plateDto?.length > 1;
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const isWellImagingEnabled = useIsWellImagingEnabled(
    selectedDropImageParameters?.dropNumber,
  );
  const toggleWellDropImaging = useToggleWellDropImage();
  const rmLite = useRMLite();

  const handlePlatesImagingToggle = () => {
    showModal({
      body: <DisablePlateImagingModal hideModal={hideModal} />,
      showButtons: false,
      heading: 'Disable Imaging Plate',
    });
  };

  const toggleExperimentImagingState = async () => {
    const plateIds = exp?.plateDto?.map((p) => p.plateId);
    const plates = plateIds.map(
      (p) =>
        new PlatesImagingTaskDTO({ plateId: p, imagingEnabled: !plateImagingEnabled }),
    );
    dispatch(togglePlateImaging({ plates }));
    await new ExperimentService().setExperimentImaging(
      exp.experimentId,
      experimentImagingDisabled,
    );
  };

  const imagingToggles: ImagingToggleProps[] = [
    {
      label: 'Imaging Experiment',
      isOn: experimentImagingDisabled,
      onToggle: toggleExperimentImagingState,
      disabled: false,
    },
    {
      label: 'Imaging Drop',
      isOn: !isWellImagingEnabled,
      onToggle: toggleWellDropImaging,
      disabled: !plateImagingEnabled,
    },
  ];

  isMultiPlateExperiment
    ? imagingToggles.push({
        label: 'Imaging Plate',
        isOn: !plateImagingEnabled,
        onToggle: handlePlatesImagingToggle,
        disabled: experimentImagingDisabled,
      })
    : null;

  const content = (
    <>
      <div style={styles.tools}>
        <SideBarComponent
          heading={'Assign Image Setting to Drop'}
          isCollapsible={true}
          handleColapse={() => {}}
          ContainerComponent={
            <div style={styles.toolsHeading}>
              <DropImageSettings disabled={rmLite} />
            </div>
          }
        />
      </div>
      <div style={styles.tools}>
        <SideBarComponent
          heading={'Disable Imaging'}
          isCollapsible={true}
          handleColapse={() => {}}
          ContainerComponent={
            <div style={styles.toolsHeading}>
              <ImagingToggles toggles={imagingToggles} />
            </div>
          }
        />
      </div>
      <SideBarComponent
        heading={'Image Tuning'}
        isCollapsible={true}
        handleColapse={() => {}}
        ContainerComponent={
          <div style={styles.tuningHeading}>
            <ImageTuning />
          </div>
        }
      />
    </>
  );

  const tabItems_: ITabItem[] = [
    {
      content,
    },
  ];

  return <BaseSidePanel tabItems={tabItems_} headerTitle={'Tools'} />;
};

const styles: IStyle = {
  mainHead: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  tools: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  toolsHeading: {
    paddingBlock: '2%',
    paddingInline: '5%',
  },
  toolsContent: {
    paddingBlock: '2%',
    paddingInline: '5%',
  },
  tuningHeading: {
    paddingBlock: '2%',
  },
};

export default ImageTuningContainer;
